import {
    OVERVIEW_EVENTS_FETCH_BY_GROUP_ERROR,
    OVERVIEW_EVENTS_FETCH_BY_GROUP_PENDING,
    OVERVIEW_EVENTS_FETCH_BY_GROUP_SUCCESS,
    OVERVIEW_SEARCH_EVENTS_CLEAR,
    OVERVIEW_SEARCH_EVENTS_FETCH_ERROR,
    OVERVIEW_SEARCH_EVENTS_FETCH_PENDING,
    OVERVIEW_SEARCH_EVENTS_FETCH_SUCCESS,
} from 'constants/overviewEvents';
import TerminalRestService from 'utils/TerminalRestService';
import { ParsproService } from 'utils/ParsproService';
import { isTerminal } from 'utils/UiHelper';

export function getPreEventsByGroupId(groupId) {
    return (dispatch) => {
        dispatch({
            type: OVERVIEW_EVENTS_FETCH_BY_GROUP_PENDING,
            payload: true,
        });

        if (!isTerminal()) {
            ParsproService.getByGroup(9600, groupId)
                .then((res) => {
                    const { data } = res;
                    dispatch({
                        type: OVERVIEW_EVENTS_FETCH_BY_GROUP_SUCCESS,
                        payload: data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: OVERVIEW_EVENTS_FETCH_BY_GROUP_ERROR,
                        payload: error.errorMessage,
                    });
                });
        } else {
            TerminalRestService.getByGroup(groupId, (data) => {
                dispatch({
                    type: OVERVIEW_EVENTS_FETCH_BY_GROUP_SUCCESS,
                    payload: data,
                });
            });
        }
    };
}

export function searchByQuery(query) {
    return (dispatch) => {
        dispatch({
            type: OVERVIEW_SEARCH_EVENTS_FETCH_PENDING,
            payload: true,
        });

        if (!isTerminal()) {
            ParsproService.getEventsByQuery(query)
                .then((res) => {
                    const { data } = res;
                    dispatch({
                        type: OVERVIEW_SEARCH_EVENTS_FETCH_SUCCESS,
                        payload: data,
                    });
                })
                .catch((error) => {
                    dispatch({
                        type: OVERVIEW_SEARCH_EVENTS_FETCH_ERROR,
                        payload: error.errorMessage,
                    });
                });
        } else {
            TerminalRestService.getEventsByQuery(query, (data) => {
                dispatch({
                    type: OVERVIEW_SEARCH_EVENTS_FETCH_SUCCESS,
                    payload: data,
                });
            });
        }
    };
}

export function clearSearch(query) {
    return (dispatch) => {
        dispatch({
            type: OVERVIEW_SEARCH_EVENTS_CLEAR,
            payload: true,
        });
    };
}
